import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import ChartOfAccountIndexPage from '../containers/ChartOfAccounts'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const ChartOfAccountsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'chart_of_accounts') {
			dispatch(changeCurrent(['chart_of_accounts']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={ChartOfAccountIndexPage} exact />
		</Switch>
  )
}

ChartOfAccountsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

ChartOfAccountsPage.defaultProps = {}

export default ChartOfAccountsPage
